import React from 'react';
import { Route } from 'react-router-dom';

import http from 'api/http';
import { componentAPI } from 'api/requests';

import NewApplication from './New';
import DetailsApplication from './Details';
import EditApplication from './Edit';

export default class Application extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      componentType: {},
      componentTypeFieldValues: [],
      componentTestReports: [],
      applicationStatus: '',
      submissionDate: '',
      submittedBy: {},
      requestInProcess: true,
      fieldsList: [],
    };

    this.types = [];
    this.categories = [];
    this.families = [];
  }

  componentDidMount() {
    const { match } = this.props;
    const { applicationId } = match.params;

    if (isFinite(applicationId)) {
      http.get(componentAPI.componentInfo(applicationId)).then(({ data }) => {
        this.setState({ ...data });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.requestInProcess &&
      this.state.applicationStatus &&
      this.props.types &&
      this.props.families &&
      this.props.categories
    ) {
      let fieldsList = this.props.types.find(type => type.id === this.state.componentType.id).componentTypeFields;
      this.setState({ fieldsList, requestInProcess: false });
    }
  }

  changeStatus = actionKey => () => {
    const { match, performActionFunction, updateComponentListEntry } = this.props;
    const { applicationId } = match.params;
    const { componentType, componentTypeFieldValues, componentTestReports, submissionDate, description } = this.state;

    performActionFunction(actionKey, applicationId).then(data => {
      if (typeof data === 'string') {
        this.setState({ applicationStatus: data }, () => {
          updateComponentListEntry(
            {},
            {
              applicationStatus: data,
              componentTestReports: componentTestReports,
              componentType: componentType,
              componentTypeFieldValues: componentTypeFieldValues,
              description: description,
              id: +applicationId,
              submissionDate: submissionDate,
            }
          );
        });
      } else {
        this.setState({ ...data }, () => {
          updateComponentListEntry({}, data);
        });
      }
    });
  };

  render() {
    const {
      match,
      user,
      createAvailableForThisStatusActionsList,
      updateComponentListEntry,
      types,
      categories,
      families,
      components,
      familiesRequestInProcess,
    } = this.props;
    const { applicationStatus, requestInProcess, fieldsList } = this.state;

    return (
      <main className='scene-wrapper'>
        <Route
          exact
          path={`${match.path.slice(0, -14)}new`}
          render={() => (
            <NewApplication
              {...this.state}
              types={types}
              categories={categories}
              components={components}
              families={families}
              updateComponentListEntry={updateComponentListEntry}
              familiesRequestInProcess={familiesRequestInProcess}
              user={user}
            />
          )}
        />

        <Route
          exact
          path={`${match.path}/details`}
          render={() => (
            <DetailsApplication
              {...this.state}
              user={user}
              requestInProcess={requestInProcess}
              categories={categories}
              families={families}
              changeStatus={this.changeStatus}
              availableActions={createAvailableForThisStatusActionsList(applicationStatus)}
            />
          )}
        />

        <Route
          exact
          path={`${match.path}/edit`}
          render={() => (
            <EditApplication
              {...this.state}
              user={user}
              fieldsList={fieldsList}
              categories={categories}
              components={components}
              families={families}
              requestInProcess={requestInProcess}
              updateComponentListEntry={updateComponentListEntry}
              familiesRequestInProcess={familiesRequestInProcess}
              updateStoredData={this.updateStoredData}
            />
          )}
        />
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/index.jsx